import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "form-horizontal form-sent-geo",
  role: "form"
}
const _hoisted_2 = { class: "form-body" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { class: "control-label" }
const _hoisted_7 = { class: "error-msg" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "control-label" }
const _hoisted_12 = { class: "error-msg" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-12" }
const _hoisted_16 = { class: "control-label" }
const _hoisted_17 = { class: "error-msg" }
const _hoisted_18 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_19 = { class: "pull-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_vue_select = _resolveComponent("vue-select")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    ref: "core",
    nested: false
  }, {
    header: _withCtx(() => [
      _createElementVNode("h4", null, _toDisplayString(_ctx.$t('components.sentGeo.modals.addMonitoredTransport')), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('components.sentGeo.modals.dateRange')), 1),
                _createVNode(_component_date_picker, {
                  modelValue: _ctx.dateRange,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateRange) = $event)),
                  range: "",
                  class: _normalizeClass({ 'custom-error': _ctx.v.sentGeo.start.$error }),
                  style: {"flex-basis":"50%"},
                  onEmitDate: _ctx.emitDate
                }, null, 8, ["modelValue", "class", "onEmitDate"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.sentGeo.start.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "vuelidate-errors"
                  }, [
                    _createElementVNode("p", _hoisted_7, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('components.sentGeo.modals.vehicle')), 1),
                _createVNode(_component_vue_select, {
                  modelValue: _ctx.v.sentGeo.imei.$model,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v.sentGeo.imei.$model) = $event)),
                  class: _normalizeClass([{ 'custom-error': _ctx.v.sentGeo.imei.$error, 'is-invalid': _ctx.v.sentGeo.imei.$error }, "flex-grow vue-select"]),
                  options: _ctx.vehicles,
                  icon: "bi bi-truck",
                  label: "label",
                  onUpdateSelect: _ctx.emitVehicle
                }, null, 8, ["modelValue", "class", "options", "onUpdateSelect"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.sentGeo.imei.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "vuelidate-errors"
                  }, [
                    _createElementVNode("p", _hoisted_12, _toDisplayString(error.$message), 1)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('components.sentGeo.modals.referenceNumber')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v.sentGeo.reference_number.$model) = $event)),
                  class: _normalizeClass([{ 'custom-error': _ctx.v.sentGeo.reference_number.$error }, "form-control input-sm"]),
                  placeholder: "prefix SENT",
                  type: "text"
                }, null, 2), [
                  [_vModelText, _ctx.v.sentGeo.reference_number.$model]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v.sentGeo.reference_number.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: error.$uid,
                    class: "vuelidate-errors"
                  }, [
                    _createElementVNode("p", _hoisted_17, _toDisplayString(error.$message), 1)
                  ]))
                }), 128)),
                (_ctx.checkFormFilteredDataVar)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.$t('components.sentGeo.modals.errorTimeLimitForVehicle')), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", {
          class: "btn btn-default",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fa fa-remove" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.sentGeo.modals.exit')), 1)
        ]),
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addSentGeo && _ctx.addSentGeo(...args)))
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fa fa-save" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.sentGeo.modals.save')), 1)
        ])
      ])
    ]),
    _: 1
  }, 512))
}